import { useEffect, useState } from "react";
import LogoImage from "../assets/images/logo.png";
import IranFlag from "../assets/images/iran-flag03.png";
import numberToPersian from "./NumberToPersian";
import axiosConfig from "./axiosConfig";
import audioFile from "../assets/beep-02.mp3";
import lastBeep from "../assets/beep-05.wav";

import { useQuery } from "react-query";

const SaloonMonitor = (props) => {
  let headInfo = [];
  let match_state = true;
  async function fetchData() {
    let response = await axiosConfig("get-saloon-points.php");
    if (response.data.status == 1) {
      headInfo = response.data.headinfo;
      match_state = response.data.match_state;
    }
  }

  let audio = new Audio(audioFile);
  let lastAudio = new Audio(lastBeep);
  useEffect(() => {
    fetchData();
  }, []);

  const { status, data, error, isFetching } = useQuery(
    "todos",
    async () => {
      const { data } = await axiosConfig.get("get-saloon-points.php");
      return data;
    },
    {
      refetchInterval: 1000,
      enabled: true,
      refetchIntervalInBackground: 1000,
    }
  );

  if (status === "success") {
    console.log(
      data.headinfo.match_minute + " : " + data.headinfo.match_second
    );
    headInfo = data.headinfo;
    match_state = data.match_state;
  }

  let roundA,
    showRoundA = "";
  let roundB,
    showRoundB = "";
  let roundC,
    showRoundC = "";
  let totalWinner,
    showTotalWinner = "";

  let roundA_blue,
    roundB_blue,
    roundC_blue = "dontshow";
  let roundA_red,
    roundB_red,
    roundC_red = "dontshow";

  if (headInfo.round_a_winner == "" || headInfo.round_a_winner == null) {
    showRoundA = "dontshow";
  }
  if (headInfo.round_b_winner == "" || headInfo.round_b_winner == null) {
    showRoundB = "dontshow";
  }
  if (headInfo.round_c_winner == "" || headInfo.round_c_winner == null) {
    showRoundC = "dontshow";
  }
  if (headInfo.total_winner == "" || headInfo.total_winner == null) {
    showTotalWinner = "dontshow";
  }

  if (headInfo.round_a_winner === "blue") {
    roundA_red = "dontshow";
    roundA_blue = "";
  } else if (headInfo.round_a_winner === "red") {
    roundA_red = "";
    roundA_blue = "dontshow";
  } else if (headInfo.round_a_winner === "white") {
    roundA_red = "dontshow";
    roundA_blue = "dontshow";
  }

  if (headInfo.round_b_winner === "blue") {
    roundB_red = "dontshow";
    roundB_blue = "";
  } else if (headInfo.round_b_winner === "red") {
    roundB_red = "";
    roundB_blue = "dontshow";
  } else if (headInfo.round_b_winner === "white") {
    roundB_red = "dontshow";
    roundB_blue = "dontshow";
  }

  if (headInfo.round_c_winner === "blue") {
    roundC_red = "dontshow";
    roundC_blue = "";
  } else if (headInfo.round_c_winner === "red") {
    roundC_red = "";
    roundC_blue = "dontshow";
  } else if (headInfo.round_c_winner === "white") {
    roundC_red = "dontshow";
    roundC_blue = "dontshow";
  }

  if (headInfo.total_winner === "blue") {
    totalWinner = "bg-primary";
  } else if (headInfo.total_winner === "red") {
    totalWinner = "bg-danger";
  } else if (headInfo.total_winner === "white") {
    totalWinner = "bg-secondary";
  }

  let matchTimerColor = "text-black";
  if (headInfo.match_minute == 0 && headInfo.match_second <= 10) {
    matchTimerColor = "text-danger";
  }

  let roundTimerColor = "text-black";
  if (headInfo.round_minute == 0 && headInfo.round_second <= 10) {
    roundTimerColor = "text-danger";
  }

  const playBeep = () => {
    audio.play();
  };

  const playLastBeep = () => {
    lastAudio.play();
  };

  console.log("Play Status: ", headInfo.play_status);

  if (headInfo.play_status == "play") {
    if (headInfo.match_minute == 0) {
      if (headInfo.match_second <= 10 && headInfo.match_second > 1) {
        playBeep();
      }
      if (headInfo.match_second == 1) {
        playLastBeep();
      }
    }
  }

  if (headInfo.play_status == "round") {
    if (headInfo.round_minute == 0) {
      if (headInfo.round_second <= 10 && headInfo.round_second > 1) {
        playBeep();
      }
      if (headInfo.round_second == 0) {
        playLastBeep();
      }
    }
  }

  let preSecond = "";
  if (headInfo.match_second < 10) {
    preSecond = "0";
  }

  let preRoundSecond = "";
  if (headInfo.round_second < 10) {
    preRoundSecond = "0";
  }

  return (
    <>
      <div className="container-full">
        <div className="row" style={{ textAlign: "center", direction: "rtl" }}>
          <div className="col-4 col-md-4 mt-5" style={{ paddingTop: "80px" }}>
            <img
              src={IranFlag}
              alt="flag"
              style={{ width: "50%", height: "auto" }}
            />
            <div className="athlete-box bg-primary mt-4">
              {headInfo.fullname_blue && headInfo.fullname_blue.length > 0
                ? headInfo.fullname_blue
                : headInfo.fullname_blue}
            </div>
            <div className="roundResultBox mt-5" style={{ paddingTop: "60px" }}>
              <div
                className={
                  "roundBox bg-primary text-white mb-3 " +
                  showRoundA +
                  " " +
                  roundA_blue
                }
              >
                راند اول
              </div>
              <div
                className={
                  "roundBox bg-primary text-white mb-3 " +
                  showRoundB +
                  " " +
                  roundB_blue
                }
              >
                راند دوم
              </div>
              <div
                className={
                  "roundBox bg-primary text-white " +
                  showRoundC +
                  " " +
                  roundC_blue
                }
              >
                راند سوم
              </div>
            </div>
          </div>
          <div className="col-4 col-md-4 mt-2">
            <img src={LogoImage} alt="logo" className="" />
            <p className="IRANSansNormal">فدراسیون ووشو جمهوری اسلامی ایران</p>
            {headInfo.play_status !== "round" && (
              <p
                className="IRANSansBold mt-5"
                style={{ fontSize: "50px", color: "#333" }}
              >
                {headInfo.match_state === "play"
                  ? "راند " + numberToPersian(headInfo.round)
                  : "پایان مسابقه"}
              </p>
            )}
            {headInfo.play_status === "round" && (
              <p
                className="IRANSansBold text-warning mt-5"
                style={{ fontSize: "50px" }}
              >
                استراحت
              </p>
            )}
            <p
              className="IRANSansBold mt-3"
              style={{ fontSize: "40px", color: "#555" }}
            >
              {numberToPersian(headInfo.weight)} کیلوگرم
            </p>
            <div
              className="row"
              style={{ textAlign: "center", direction: "ltr" }}
            >
              <div className="col-12 col-md-12">
                {headInfo.match_state === "play" &&
                  headInfo.play_status !== "round" && (
                    <p
                      className={"IRANSansBold " + matchTimerColor}
                      style={{ fontSize: "170px" }}
                    >
                      {" "}
                      {numberToPersian(headInfo.match_minute)} :&nbsp;
                      {preSecond != "" ? numberToPersian(preSecond) : ""}
                      {numberToPersian(headInfo.match_second)}
                    </p>
                  )}
                {headInfo.match_state === "end" && (
                  <p
                    className={"IRANSansBold " + matchTimerColor}
                    style={{ fontSize: "170px" }}
                  >
                    - : -
                  </p>
                )}
                {headInfo.play_status === "round" && (
                  <p
                    className={"IRANSansBold " + roundTimerColor}
                    style={{ fontSize: "170px" }}
                  >
                    {" "}
                    {numberToPersian(headInfo.round_minute)} :&nbsp;
                    {preRoundSecond != ""
                      ? numberToPersian(preRoundSecond)
                      : ""}
                    {numberToPersian(headInfo.round_second)}
                  </p>
                )}
              </div>
              <div className="col-12 col-md-12">
                <div
                  className={
                    "finalWinnerBox bg-primary text-white " +
                    showTotalWinner +
                    " " +
                    totalWinner
                  }
                  style={{ border: "10px solid #daae43" }}
                >
                  برنده مسابقه
                </div>
              </div>
            </div>
          </div>
          <div className="col-4 col-md-4 mt-5" style={{ paddingTop: "80px" }}>
            <img
              src={IranFlag}
              alt="flag"
              style={{ width: "50%", height: "auto" }}
            />
            <div className="athlete-box bg-danger mt-4">
              {headInfo.fullname_red && headInfo.fullname_red > 0
                ? headInfo.fullname_red
                : headInfo.fullname_red}
            </div>
            <div
              className="roundResultBox mt-5"
              style={{ paddingTop: "60px", direction: "ltr" }}
            >
              <div
                className={
                  "roundBox bg-danger text-white mb-3 " +
                  showRoundA +
                  " " +
                  roundA_red
                }
              >
                راند اول
              </div>
              <div
                className={
                  "roundBox bg-danger text-white mb-3 " +
                  showRoundB +
                  " " +
                  roundB_red
                }
              >
                راند دوم
              </div>
              <div
                className={
                  "roundBox bg-danger text-white " +
                  showRoundC +
                  " " +
                  roundC_red
                }
              >
                راند سوم
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SaloonMonitor;
